import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-section04',
  templateUrl: './section04.component.html',
  styleUrls: ['./section04.component.scss']
})

export class Section04Component implements OnInit {
  @Input() data;

  constructor() {
  }

  ngOnInit() {
  }

}
